const sx = {
	icon(p = {}) {
		return {
			position: 'relative',
			transformOrigin: '50%',
			width: 11,
			height: 11,
			transition: '.2s transform',
			...(p.open ? { transform: 'rotate(180deg)' } : {}),
		};
	},
};

export default sx;
